import type { InjectionKey, Ref } from "vue"
import type { EventVault } from "@/models"

export const EventVaultIdKey = Symbol("EventVaultIdKey") as InjectionKey<number | undefined>
export const EventVaultProviderKey = Symbol("EventVaultProviderKey") as InjectionKey<Ref<EventVault | undefined>>
